// Module
var code = "<template> <require from=\"app/pp/components/summary/patient-summary\"></require> <patient-summary member-id.bind=\"member.id\"> </patient-summary></template> ";
// Exports
module.exports = code;